export function resolveLinkedFields(task, ct) {
    if (!task.componentRef || !task.linkedFields || !ct) return { ...task }
    const clone = { ...task }
    const fields = task.linkedFields
    if (fields.title && ct.heading != null) clone.title = ct.heading
    if (fields.content && ct.actionsHtml != null) clone.content = ct.actionsHtml
    if (fields.notes && ct.notesHtml != null) clone.note = ct.notesHtml
    if (fields.classification && ct.classification != null) clone.classification = ct.classification
    if (fields.duration && ct.minutes != null) clone.minutes = ct.minutes
    if (fields.frequency && (ct.frequency || ct.frequencyCode)) {
        clone.frequency = ct.frequency ?? parseFrequencyCode(ct.frequencyCode)
    }
    if (fields.skillSet && ct.skillSet != null) clone.skillSet = ct.skillSet
    return clone
}

function parseFrequencyCode(code) {
    if (!code) return null
    const periods = { H: "Hour", D: "Day", W: "Week", M: "Month", Y: "Year", U: "Unknown" }
    const match = code.match(/^(\d+)([HDWMYU])$/i)
    if (!match) return null
    return { interval: parseInt(match[1], 10), period: periods[match[2].toUpperCase()] || "Unknown" }
}
